import { If, UnborderCollapse, UnderlineMoneyInput } from 'aa_common/front-end/components'
import { everyTrue } from 'aa_common/front-end/helpers'
import { DEPRECIATION_METHOD_CODE } from 'common/constants'
import { loadNs } from 'common/i18n-config'
import { FORM_MODES } from 'common/models'
import { getIn, useFormikContext } from 'formik'
import React, { useEffect } from 'react'

import { DEPRECIATION_FIELDS } from '../const'
import { genLedgerFieldName } from '../helper'
import { useClearValueOnHide } from '../hooks/useClearOnHide'

const { Item } = UnborderCollapse

const t = loadNs(['components/organisms/assets/asset-form', 'common'])

type AccumulatedDepreciationAmountProps = {
  ledgerIndex: number
  formMode: FORM_MODES
}

export const AccumulatedDepreciationAmount = ({ ledgerIndex, formMode }: AccumulatedDepreciationAmountProps) => {
  const { values, setFieldValue } = useFormikContext()

  const depreciationMethodCodeField = genLedgerFieldName(DEPRECIATION_FIELDS.DEPRECIATION_METHOD_CODE, ledgerIndex)
  const accumulatedDepreciationAmount = genLedgerFieldName(
    DEPRECIATION_FIELDS.ACCUMULATED_DEPRECIATION_AMOUNT,
    ledgerIndex
  )

  const hasTransition = getIn(values, 'has_transition')
  const depreciationCode = getIn(values, depreciationMethodCodeField)

  const shouldRender = everyTrue(
    hasTransition,
    ![FORM_MODES.NEW, FORM_MODES.COPY].includes(formMode),
    ![DEPRECIATION_METHOD_CODE.NON_DEPRECIATION, DEPRECIATION_METHOD_CODE.NON_DEPRECIABLE].includes(depreciationCode)
  )

  useClearValueOnHide(accumulatedDepreciationAmount, setFieldValue, shouldRender)

  useEffect(() => {
    if (shouldRender && depreciationCode === DEPRECIATION_METHOD_CODE.SMALL_AMOUNT_DEPRECIABLE_ASSET) {
      setFieldValue(accumulatedDepreciationAmount, undefined)
    }
  }, [shouldRender, depreciationCode, setFieldValue, accumulatedDepreciationAmount])

  return (
    <If condition={shouldRender}>
      <Item label={t('accumulated_depreciation_amount')}>
        <UnderlineMoneyInput style={{ textAlign: 'right' }} name={accumulatedDepreciationAmount} />
      </Item>
    </If>
  )
}
